var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 42,
    rx: 6,
    fill: "url(#paint0_linear_11037_3994)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.0001C24.5387 21.0001 27 18.4642 27 15.3334C27 12.2026 24.5387 9.66675 21.5 9.66675C18.4612 9.66675 16 12.2026 16 15.3334C16 18.4642 18.4612 21.0001 21.5 21.0001ZM21.5 23.8334C17.8287 23.8334 10.5 25.7317 10.5 29.5001V32.3334H32.5V29.5001C32.5 25.7317 25.1713 23.8334 21.5 23.8334Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11037_3994",
    x1: -6.84091,
    y1: 2.40096e-7,
    x2: 37.5884,
    y2: 40.9802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin-icon.826e58ae81e34099e504ab1d1c06bec2.svg";
export { ForwardRef as ReactComponent };